<template>
  <div class="pt-4 px-4 w-full">
    <div class="flex w-full justify-center rounded-md border-2 border-dashed border-gray-300 px-6 pt-5 pb-6">
      <div class="space-x-2 flex text-center items-center">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-gray-400 w-8 h-8">
          <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
        </svg>
        <div class="flex text-lg text-gray-600">
          <label for="file-upload" class="relative cursor-pointer rounded-md bg-white font-medium text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:text-indigo-500">
            <span>Upload an image</span>
            <input
              v-if="showFile"
              id="file-upload"
              name="file-upload"
              ref="editor-upload"
              type="file"
              class="sr-only"
              accept="image/*"

              @change="change"
              multiple
            >
          </label>
          <p class="pl-1">or drag and drop</p>
        </div>
      </div>
    </div>
    <!-- <input type="file" ref="editor-upload" accept="image/*" style="display: none" @change="change" multiple> -->
  </div>
</template>

<script>

import { mapGetters } from "vuex"

export default {
  data() {
    return {
      showFile: true,
    }
  },
  methods: {
    async change(evt) {
      const files = [...this.$refs["editor-upload"].files]
      await Promise.all(
        files.map(async file => {
          const payload = new FormData()
          payload.append("filename", file)
          payload.append("type", "frontpage_01")

          try {
            await this.axios.post(`/api/websites/${this.website.uid}/files`, payload, {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            })
            this.$store.dispatch('clearCacheSearch', "websites")
            await this.$store.dispatch("toast/success", { message: "Successfully uploaded files!" })
          } catch (err) {
            await this.$store.dispatch("toast/handleError", err)
          }
        })
      )

      this.$emit("refetch-images")
      // this.$success("Bestanden succesvol geüpload!")
    },
  },
  computed: {
    ...mapGetters({
      website: 'editor/website',
    }),
  },
}

</script>
